import Card from 'components/Card';
import EnvelopeListSidebar from 'components/EnvelopeList/EnvelopeListSidebar';
import LinkLookup from 'components/LinkLookup';
import LoadingIndicator from 'components/LoadingIndicator';
import Navbar from 'components/Navbar';
import Permissions from 'components/Permissions';
import { LEFT_ARROW_ICON } from 'constants/envelopeIcons';
import React, { useEffect } from 'react';
import ReactJson from 'react-json-view';

import { useSelector } from 'store';
import { NAV_BAR_HEIGHT_REM } from 'utils/dimensions';
import { useDispatch } from 'react-redux';
import { reindexComms } from 'actions';
import { fetchIndexHealthSample } from 'actions/customers';
import { getIndexHealthSampleLoading, getIndexHealthSample } from 'selectors/customers';

const CustomerIndexHealth: React.FC = () => {
  const dispatch = useDispatch();
  const errorMessage = '';
  const loading = useSelector(getIndexHealthSampleLoading);
  const indexHealthSample = useSelector(getIndexHealthSample);

  useEffect(() => {
    dispatch(fetchIndexHealthSample());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const warningBarOffset =
    document != null &&
    document.getElementById != null &&
    document.getElementById('customer-warning')?.offsetHeight;

  const header = (
    <div className="flex flex-row justify-between p-6">
      <div className="flex items-center gap-4">
        <LinkLookup routeName="customer" className="focus:outline-none">
          {LEFT_ARROW_ICON}
        </LinkLookup>
        <span className="text text--large text--bold">Index health</span>
        {loading ? <LoadingIndicator /> : null}
      </div>
      <div>
        <div className="flex items-center gap-3">
          <button
            type="button"
            className="button button--secondary px-4 py-2"
            onClick={(): void => {
              dispatch(reindexComms());
            }}
          >
            Reindex with current filters
          </button>
          <button
            type="button"
            className="button button--primary px-4 py-2"
            disabled={loading}
            onClick={(): void => {
              dispatch(fetchIndexHealthSample());
            }}
          >
            Run sample with current filters
          </button>
        </div>
      </div>
      {errorMessage ? <p className="text-small text-red-600">{errorMessage}</p> : null}
    </div>
  );

  const body =
    indexHealthSample && Object.keys(indexHealthSample).length > 0 ? (
      <div className="px-5 py-4">
        <ReactJson
          src={indexHealthSample}
          theme="chalk"
          style={{ paddingTop: '10px', paddingBottom: '25px' }}
          shouldCollapse={(field): boolean => field.name === 'indexes'}
        />
      </div>
    ) : (
      <div className="px-6 pb-8 text-small text-litlingo-gray-2">
        {loading ? null : 'Run a sample to load index health data.'}
      </div>
    );

  return (
    <Permissions field="customers.config">
      <div className="bg-white">
        <Navbar />
        <div
          className="relative flex flex-row"
          style={{
            height: `calc(100vh - ${warningBarOffset ?? 0}px - ${NAV_BAR_HEIGHT_REM}rem)`,
          }}
        >
          <EnvelopeListSidebar />
          <div className="flex-1 overflow-auto litlingo-gray-bg-color-4">
            <div className="mx-auto max-w-5xl py-2">
              <Card items={[header, body]} />
            </div>
          </div>
        </div>
      </div>
    </Permissions>
  );
};

export default CustomerIndexHealth;
